import React from 'react'
import useBigScreen from "@/hooks/bigScreen"
import style from './index.module.less'
import { LearnBuyBtn } from "@/new_components"
import { useIntl } from "react-intl"

const BaseBox = ({intro}) => {
  const intl = useIntl()
  const ifPc = useBigScreen(1000)
  console.log(8989, intro)
  const { video_src, tip, devName, desc, img, aspectRatio, justifyContent, btnLearn, btnBuy, learn_link, buy_link } = intro
  const defaultSty = {
    dfAR: ifPc ? "16 / 9" : "4 / 3",
    dfJC: "flex-end",
  }


  return (
    /* BaseBox的子元素位置可配置：
          纵向底部对齐
          纵向顶部对齐
          纵向两端对齐
    */ 

    <div 
      className={style.BaseBox} 
      style={{
        backgroundImage: img ? `url(${img})` : "",
        marginBottom: 20,
        aspectRatio: aspectRatio || defaultSty.dfAR,
        justifyContent: justifyContent || defaultSty.dfJC
      }}
    >

      {video_src && <video
        className={style.videos}
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={video_src} type="video/mp4" />
      </video>}

      {/* <div className={style.baseboxBottom}> */}
        <div className={style.baseboxContent}>
          {tip && <div className={style.tip}>{intl.formatMessage({ id: tip })}</div>}
          <div className={style.devName}>{intl.formatMessage({ id: devName })}</div>
          <div className={style.desc}>{intl.formatMessage({ id: desc })}</div>
        </div>

        <div className={style.baseboxBtn}>
          {learn_link && <LearnBuyBtn link={learn_link} link_out={false} btnText={btnLearn} btnType="learn" />}
          {buy_link && <LearnBuyBtn link={buy_link} link_out={true} btnText={btnBuy} btnType="buy" />}
        </div>
      {/* </div> */}
      
    </div>
  )
}

export default BaseBox
